import { faCirclePlus, faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Form } from "react-bootstrap";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";
import { useEffect, useState } from "react";

function ProcedureManual_Form({handleClose}) {
   const [success, setSuccess] = useState(false);

  // ⏱ auto hide success toaster after 3 sec
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [success]);

  return (
    <>
      <section className="Legal_Entity_Form">
        <div className="white_container customer_section">
          <div className="row">
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Procedure Manual Name</Form.Label>
                <Form.Control value="Enter Manual Name" disabled />
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="form_group file_field">
                <Form.Label>Attach Procedure Manual Document</Form.Label>
                <div className="absolute_fields">
                  <Form.Control value="Upload File" disabled />
                  <div className="upload_icon_holder">
                    <FontAwesomeIcon icon={faUpload} className="upload_icon" />
                  </div>
                </div>
                {/* <div className="image_holder">
                  <img
                    className="img_preview"
                    src="/assets/images/other/dummy-image.png"
                  />
                </div> */}
              </Form.Group>

              <div className="add_another_holder">
                <div>
                  <span><FontAwesomeIcon icon={faCirclePlus} /> Add Another Document</span>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Remark(Optional)</Form.Label>
                <Form.Control value="Enter Manual Name" disabled />
              </Form.Group>
            </div>


            
          </div>

           <div className="permission_btn_holder">
            {success ? (
              <Success_Toster successText="Save Audit Successfully!" />
            ) : (
              <>
                <Button type="button" className="permission_btn No_btn">
                  Cancel
                </Button>

                <Button
                  type="button"
                  className="permission_btn Yes_btn"
                  onClick={() => setSuccess(true)}
                >
                  Save
                </Button>
              </>
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default ProcedureManual_Form;
